import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import DashBoard from "../components/Dashboard";
import { IS_USER_AUTHENTICATED_GETTER } from "../store/storeconstants";

const routes = [
  {
    path: "/mobile-frr",
    component: () => import("../views/MobileFrrFallback.vue"),
    meta: { auth: false },
  },
  {
    path: "/launch_field_wall",
    component: () => import("../views/LaunchField.vue"),
    meta: { auth: true },
  },
  {
    path: "",
    component: DashBoard,
    children: [
      {
        path: "home",
        component: () => import("../views/Home.vue"),
        meta: { auth: false },
      },
      {
        path: "staff",
        component: () => import("../views/Staff.vue"),
        meta: { auth: false },
      },
      {
        path: "login",
        component: () => import("../views/Login.vue"),
        meta: { auth: false },
      },
      {
        path: "register",
        component: () => import("../views/Register.vue"),
        meta: { auth: false },
      },
      {
        path: "users",
        component: () => import("../views/Users.vue"),
        meta: { auth: true },
      },
      {
        path: "useraccount",
        component: () => import("../views/Useraccount.vue"),
        meta: { auth: true },
      },
      {
        path: "categories",
        component: () => import("../views/Categories.vue"),
        meta: { auth: true },
      },
      {
        path: "newcategory",
        component: () => import("../views/Newcategory.vue"),
        meta: { auth: true },
      },
      {
        path: "teams",
        component: () => import("../views/Teams.vue"),
        meta: { auth: true },
      },
      {
        path: "newteam",
        component: () => import("../views/Newteam.vue"),
        meta: { auth: true },
      },
      {
        path: "main",
        component: () => import("../views/Admin.vue"),
        meta: { auth: true },
      },
      {
        path: "teb",
        component: () => import("../views/Teb.vue"),
        meta: { auth: true },
      },
      {
        path: "newteb",
        component: () => import("../views/Newteb.vue"),
        meta: { auth: true },
      },
      {
        path: "projects",
        component: () => import("../views/Projects.vue"),
        meta: { auth: true },
      },
      {
        path: "resetpassword",
        component: () => import("../views/Resetpassword.vue"),
        meta: { auth: false },
      },
      {
        path: "newproject",
        component: () => import("../views/Newproject.vue"),
        meta: { auth: true },
      },
      {
        path: "frr_parameters",
        component: () => import("../views/Frrparameters.vue"),
        meta: { auth: true },
      },
      {
        path: "frr_projects",
        component: () => import("../views/Frrprojects.vue"),
        meta: { auth: true },
      },
      {
        path: "newgroup",
        component: () => import("../views/Newgroup.vue"),
        meta: { auth: true },
      },
      {
        path: "newaction",
        component: () => import("../views/Newaction.vue"),
        meta: { auth: true },
      },
      {
        path: "newparameter",
        component: () => import("../views/Newparameter.vue"),
        meta: { auth: true },
      },
      {
        path: "frr",
        component: () => import("../views/Frr.vue"),
        meta: { auth: true },
      },
      {
        path: "frr_projects_teb",
        component: () => import("../views/Frrteb.vue"),
        meta: { auth: true },
      },
      {
        path: "tr_parameters",
        component: () => import("../views/Trparameters.vue"),
        meta: { auth: true },
      },
      {
        path: "newcriterion",
        component: () => import("../views/Newcriterion.vue"),
        meta: { auth: true },
      },
      {
        path: "gradingparams",
        component: () => import("../views/Gradingparams.vue"),
        meta: { auth: true },
      },
      {
        path: "newgradingparam",
        component: () => import("../views/Newgradingparam.vue"),
        meta: { auth: true },
      },
      {
        path: "newtrdetail",
        component: () => import("../views/Newtrdetail.vue"),
        meta: { auth: true },
      },
      {
        path: "tr_projects",
        component: () => import("../views/Trprojects.vue"),
        meta: { auth: true },
      },
      {
        path: "tr",
        component: () => import("../views/Tr.vue"),
        meta: { auth: true },
      },
      {
        path: "tr_admin",
        component: () => import("../views/TRAdmin.vue"),
        meta: { auth: true },
      },
      {
        path: "pl_projects",
        component: () => import("../views/PL_projects.vue"),
        meta: { auth: true },
      },
      {
        path: "payload",
        component: () => import("../views/Payload.vue"),
        meta: { auth: true },
      },
      {
        path: "payload_admin",
        component: () => import("../views/PayloadAdmin.vue"),
        meta: { auth: true },
      },
      {
        path: "design_projects",
        component: () => import("../views/VD_projects.vue"),
        meta: { auth: true },
      },
      {
        path: "design",
        component: () => import("../views/Design.vue"),
        meta: { auth: true },
      },
      {
        path: "design_admin",
        component: () => import("../views/DesignAdmin.vue"),
        meta: { auth: true },
      },
      {
        path: "flight_projects",
        component: () => import("../views/FP_projects.vue"),
        meta: { auth: true },
      },
      {
        path: "flight_admin",
        component: () => import("../views/FlightAdmin.vue"),
        meta: { auth: true },
      },
      {
        path: "scoring_reports",
        component: () => import("../views/ScoringReports.vue"),
        meta: { auth: true },
      },
      {
        path: "scoring_dashboard",
        component: () => import("../views/ScoringDashboard.vue"),
        meta: { auth: true },
      },
      {
        path: "effort_projects",
        component: () => import("../views/TE_projects.vue"),
        meta: { auth: true },
      },
      {
        path: "teffort",
        component: () => import("../views/Teffort.vue"),
        meta: { auth: true },
      },
      {
        path: "teffort_admin",
        component: () => import("../views/TEadmin.vue"),
        meta: { auth: true },
      },
      {
        path: "flight_profile",
        component: () => import("../views/FProfile.vue"),
        meta: { auth: true },
      },
      {
        path: "stats",
        component: () => import("../views/Stats.vue"),
        meta: { auth: true },
      },
      {
        path: "reports",
        component: () => import("../views/Stats.vue"),
        meta: { auth: true },
      },
      {
        path: "launch_field",
        component: () => import("../views/LaunchField.vue"),
        meta: { auth: true },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

//process.env.BASE_URL

router.beforeEach((to, from, next) => {
  if (to.path === "/" && to.query.launchField === "wall") {
    return next({
      path: "/launch_field_wall",
      query: { display: "wall" },
    });
  }

  if (to.path === "/" && to.query.launchField === "final") {
    return next({
      path: "/launch_field",
      query: { view: "final" },
    });
  }

  // BLOCK all router navigations if there are unsaved changes
  if (
    store.getters["ui/HAS_UNSAVED_CHANGES"] &&
    to.fullPath !== from.fullPath
  ) {
    // No confirm — just block.
    return next(false);
  }

  // Your existing auth guard
  if (
    to.meta.requiresAuth &&
    !store.getters[`auth/${IS_USER_AUTHENTICATED_GETTER}`]
  ) {
    return next({
      path: "login",
      query: { redirectTo: to.fullPath },
    });
  }

  next();
});

export default router;
